// Why Apex Experience - Data source
// Differentiators, guarantee, and statistics

export interface Differentiator {
  id: number;
  title: string;
  description: string;
  features: string[];
}

export interface Stat {
  id: string;
  number: string;
  label: string;
}

export const differentiators: Differentiator[] = [
  {
    id: 1,
    title: "100% Customized Experiences",
    description:
      "No two itineraries are the same. Each experience is designed from scratch according to your preferences, experience level, interests, and expectations. You won't adapt to a generic tour; the tour adapts completely to you.",
    features: [
      "Private itineraries designed to measure",
      "Total flexibility for adjustments during the trip",
      "Personalized 24/7 attention",
      "Small groups or completely private experiences",
    ],
  },
  {
    id: 2,
    title: "Elite Certified Guides",
    description:
      "Our guides aren't just technical experts with international certifications (IFMGA, AMGA). They're passionate storytellers, deep connoisseurs of local culture, and true lovers of these mountains.",
    features: [
      "IFMGA certifications (International Federation of Mountain Guides)",
      "Minimum 10 years of experience in the Andes",
      "Wilderness first aid WFR training",
      "Fluent in Spanish, English, and other languages",
    ],
  },
  {
    id: 3,
    title: "Exclusive Access to Unique Locations",
    description:
      "After more than a decade operating in Chile, we've cultivated relationships with boutique lodge owners, local guides, and communities that allow us to access places inaccessible to the general public.",
    features: [
      "Private lodges not publicly listed",
      "Exclusively reserved skiing and fishing areas",
      "Special permits for protected areas",
      "Direct relationships with local communities",
    ],
  },
  {
    id: 4,
    title: "Professional-Level Equipment",
    description:
      "We work exclusively with the world's best brands and constantly renew our equipment. Everything is reviewed before each outing to guarantee optimal performance and absolute safety.",
    features: [
      "Latest generation skis, boots, and technical equipment",
      "High-end fishing gear (Orvis, Sage, Simms)",
      "Satellite communication on all remote expeditions",
      "Luxury private transport (helicopters, premium 4x4s)",
    ],
  },
  {
    id: 5,
    title: "Environmental and Social Commitment",
    description:
      "We operate under strict sustainability principles. We not only minimize our impact, but actively contribute to conservation and development of local communities.",
    features: [
      '"Leave No Trace" policy on all expeditions',
      "Partnerships with local conservation organizations",
      "Preferential local employment in our operations",
      "Direct economic contribution to rural communities",
    ],
  },
  {
    id: 6,
    title: "Authentic Luxury, Not Ostentatious",
    description:
      "Our concept of luxury isn't champagne in crystal glasses (though we have that if you want it). It's sleeping in architectural lodges in the middle of nowhere, eating freshly caught trout prepared by gourmet chefs, and having private access to pristine mountains.",
    features: [
      "Boutique accommodations with their own identity",
      "Gourmet cuisine with local ingredients",
      "Intimate experiences, never massive",
      "Impeccable details without losing connection to nature",
    ],
  },
];

export const stats: Stat[] = [
  {
    id: "satisfaction",
    number: "98%",
    label: "Client satisfaction rate",
  },
  {
    id: "repeat",
    number: "85%",
    label: "Clients who repeat or refer",
  },
  {
    id: "experience",
    number: "10+",
    label: "Years of experience in the Andes",
  },
  {
    id: "safety",
    number: "100%",
    label: "Impeccable safety record",
  },
];

export const guarantee = {
  intro: "We're so confident in the quality of our experiences that we offer a simple promise:",
  text: "If any aspect of your experience with Apex doesn't meet your expectations, we'll work with you until you're completely satisfied. Your trust is our most valuable asset.",
};
